import React from 'react';
import PropTypes from 'prop-types';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import { PrimaryButton } from 'DesignSystem/Buttons';
import { ProductContent } from 'DesignSystem/Typography';
import { setIsRecipientPreviewModalVisible } from 'SelfServeBuilder/SelfServeBuilderActions';

class RecipientPreviewEmptyStateTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.closeRecipientPreview = this.closeRecipientPreview.bind(this);
  }

  closeRecipientPreview() {
    this.props.setIsRecipientPreviewModalVisible(false);
  }

  render() {
    return (
      <div className="recipient-preview-empty-state-tooltip">
        <img
          alt="what-is-your-name-illustration"
          className="what-is-your-name-illustration"
          src="/images/self-serve-builder/what-is-your-name-illustration.png"
        />
        <ProductContent
          className="self-serve-empty-state-tooltip-text"
          variation="smallest"
        >
          Your recipient will see your fillable field label in this questionnaire format.
        </ProductContent>
        <ProductContent
          className="self-serve-empty-state-tooltip-text bold"
          variation="smallest"
        >
          To test the recipient preview:
        </ProductContent>
        <PrimaryButton
          className="back-to-fillable-fields-btn"
          onClick={this.closeRecipientPreview}
        >
          Go Back and Add Fillable Fields
        </PrimaryButton>
      </div>
    );
  }
}

RecipientPreviewEmptyStateTooltip.propTypes = {
  setIsRecipientPreviewModalVisible: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    setIsRecipientPreviewModalVisible,
  }, dispatch)
);

const RecipientPreviewEmptyStateTooltipWithRedux = ReactRedux.connect(
  null,
  mapDispatchToProps,
)(RecipientPreviewEmptyStateTooltip);

export default RecipientPreviewEmptyStateTooltipWithRedux;



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/RecipientPreviewEmptyStateTooltip.jsx